import { Component, OnInit, ViewChild } from '@angular/core';
import { filterBy } from '@progress/kendo-data-query';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { HRMSService } from 'app/hrms/shared/hrms.service';
import { DateService } from 'app/date/date.service';
import * as firebase from 'firebase-admin';
const data = [
  { name: "Alfa", category: "Food", subcategory: "Alfa" },
  { name: "Beta", category: "Food", subcategory: "Beta" },
  { name: "Gama", category: "Food", subcategory: "Gama" }
];
const result = filterBy(data, {
logic: 'and',
filters: [
    { field: "name", operator: "startswith", value: "p", ignoreCase: true },
    { field: "subcategory", operator: "eq", value: "Meat" },
]
});
@Component({
  selector: 'app-testcomponent',
  templateUrl: './testcomponent.component.html',
  styleUrls: ['./testcomponent.component.scss']
})
export class TestcomponentComponent implements OnInit {

  constructor(private hrmsService:HRMSService, private dateService:DateService) { 
    /* firebase.auth().getUserByEmail("superadmin@gmail.com")
  .then((userRecord) =>{
    // See the tables above for the contents of userRecord
    console.log("Successfully fetched user data:", userRecord.toJSON());
  })
  .catch(function(error) {
    console.log("Error fetching user data:", error);
  }); */
  /* firebase.auth().deleteUser("uid")
  .then(function() {
    console.log('Successfully deleted user');
  })
  .catch(function(error) {
    console.log('Error deleting user:', error);
  }); */
  }

  ngOnInit() {
    console.log(JSON.stringify(result, null, 2));
/* output
[
    { "name": "Pork", "category": "Food", "subcategory": "Meat" }
]
*/
this.getAttendanceLogs();
this.getPReviousDate();
  }
  getPReviousDate()
  {
    var d = new Date();
    d.setDate(d.getDate() - 1234);
    console.log("attendancedate",d);
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    console.log("tomorrow",tomorrow);
    var date = new Date(this.dateService.getTodaysDate()), y = date.getFullYear(), m = date.getMonth();
    var firstDay = new Date(y, m, date.getDate());
    var lastDay = new Date(y, m, date.getDate() - 30);
    console.log("firstDay",firstDay,lastDay);
    var attendanceDate = d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate();
    console.log("attendanceDate",attendanceDate);
    
  }
  tabsInitialized: boolean = false;
    @ViewChild('tabs') public tabs:NgbTabset;

    ngAfterViewInit() {
     this.tabsInitialized = true;
    }
    
    ngOnChanges(){
     if(this.tabsInitialized){
      this.tabs.select('dashboard');
    }
   }
   getAttendanceLogs()
   {
     var date1 = new Date("2019-05-01");
     var date2 = new Date("2019-05-12");
     this.hrmsService.findDate(String(date1.getTime()),String(date2.getTime())).once("value").then((data)=>{
       console.log("data",data.val());
       
     });
   }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/testcomponent/testcomponent.component.ts